import { type ApolloClient } from "@apollo/client";
import { createApolloClient } from "@package/ui-apollo";
import { useAuthState } from "@package/ui-authentication";
import { useConfigState } from "@package/ui-config";
import { useOrganizationState } from "@package/ui-organization";
import { useEffect, useState } from "react";

export function useAnalyticsApolloClient(
  apolloClient?: ApolloClient<object>,
): ApolloClient<object> | undefined {
  const [client, setClient] = useState<ApolloClient<object>>();

  const { apollo, baseUrlApiAnalytics, environment } = useConfigState();
  const { token, tokenDecoded } = useAuthState();
  const { selectedOrganization } = useOrganizationState();

  useEffect(
    function effectOnApolloClient() {
      const createClient = async () => {
        if (token && tokenDecoded) {
          setClient(
            await createApolloClient({
              ...apollo,
              environment,
              organization: selectedOrganization?.orgId,
              token,
              uri: `${baseUrlApiAnalytics}/api/graphql`,
            }),
          );
        }
      };

      if (apolloClient) {
        setClient(apolloClient);
      } else {
        createClient();
      }
    },
    [
      apollo,
      apolloClient,
      baseUrlApiAnalytics,
      environment,
      selectedOrganization?.orgId,
      token,
      tokenDecoded,
    ],
  );

  return client;
}
